<div #svgIconContainer class="si-svg-icon"></div>
